import { times } from '@sama/micro-dash';
import { mapPoint } from '../../../shared/misc-utilities/point-utils';

export type RGB = [number, number, number];
export type RGBA = [number, number, number, number];

export function toRgbDomString(rgb: RGB) {
  return `rgb(${rgb.join(', ')})`;
}

export function createDistinctColors(num: number, saturation = 1) {
  return times(num, (i) =>
    mapPoint(hsv2rgb(i / num, saturation, 1), (x) => Math.round(x * 255)),
  );
}

/**
 * Taken from js-segment-annotator:
 * https://github.com/kyamagu/js-segment-annotator
 */
// eslint-disable-next-line max-lines-per-function,complexity -- if you need to modify this code, fix this first
export function hsv2rgb(h: number, s: number, v: number): RGB {
  const i = Math.floor(h * 6);
  const f = h * 6 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  let r: number;
  let g: number;
  let b: number;
  switch (i % 6) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    default:
      r = v;
      g = p;
      b = q;
  }
  return [r, g, b];
}
